import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Editor } from '@tiptap/core';

@Component({
  selector: 'app-tiptap-toolbar',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  templateUrl: './tiptap-toolbar.component.html',
  styleUrl: './tiptap-toolbar.component.scss',
})
export class TiptapToolbarComponent {
  @Input() editor: Editor;
  @Input() disabled = false;

  @Output() undo = new EventEmitter<void>();
  @Output() redo = new EventEmitter<void>();

  onUndo() {
    this.editor.commands.undo();
    this.undo.emit();
  }
  onRedo() {
    this.editor.commands.redo();
    this.undo.emit();
  }
}
